import React from "react";

// ASSETS

// STYLES
import {
  PartnersCard,
  PartnersCardButtonWrapper,
  PartnersCardComponent,
  PartnersCardContent,
  PartnersCardIconWrapper,
  PartnersCardTextWrapper,
  PartnersCardTitleWrapper,
  PartnersIconComponent,
  PartnersSectionContainer,
} from "./PartnersSectionStyled";

// LIBRARIES
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import { appRoutes } from "config/AppRoutesConfig";

// REDUX

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import CustomText from "components/Atoms/CustomText/CustomText";

const PartnersSection = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const isMobile = useMediaQuery({ maxWidth: 1120 });
  const navigate = useNavigate();
  const { t } = useTranslation();
  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <PartnersSectionContainer>
      <PartnersCardComponent>
        {!isMobile && (
          <PartnersCardTitleWrapper>
            <CustomText
              text={t("view.about.aboutDSU.partnersSection.title")}
              type={TextType.H2}
              color={COLORS.VividAuburn}
            />
            {/* 
            <CustomText
              text={t("view.about.aboutDSU.partnersSection.subtitle")}
              type={TextType.H2}
              color={COLORS.RaisinBlack}
            /> */}
          </PartnersCardTitleWrapper>
        )}
        <PartnersCard>
          <PartnersCardIconWrapper>
            <PartnersIconComponent />
          </PartnersCardIconWrapper>
          <PartnersCardContent>
            {isMobile && (
              <PartnersCardTitleWrapper>
                <CustomText
                  text={t("view.about.aboutDSU.partnersSection.title")}
                  type={TextType.H2}
                  color={COLORS.Cultured}
                />
                {/* 
                <CustomText
                  text={t("view.about.aboutDSU.partnersSection.subtitle")}
                  type={TextType.H2}
                  color={COLORS.RaisinBlack}
                /> */}
              </PartnersCardTitleWrapper>
            )}
            <PartnersCardTextWrapper>
              <CustomText
                text={t("view.about.aboutDSU.partnersSection.text")}
                type={TextType.P1}
                color={COLORS.Background}
              />
            </PartnersCardTextWrapper>
            <PartnersCardButtonWrapper>
              <ButtonAtom
                text={t("view.about.aboutDSU.partnersSection.buttonText")}
                type={ButtonType.RedButtonWhiteIcon}
                rightIcon={true}
                onClick={() => navigate(appRoutes.partners)}
              />
            </PartnersCardButtonWrapper>
          </PartnersCardContent>
        </PartnersCard>
      </PartnersCardComponent>
    </PartnersSectionContainer>
  );
};

export default PartnersSection;
